export default "__VITE_PUBLIC_ASSET__f3fd15a8__"